export default "__VITE_ASSET__Da80SHye__"